import type { IAccountEditDTO, ILoginDTO, IRegisterDTO, IUser } from '@types'
import AuthAdapter from '@adapters/AuthAdapter'
import StoresHelper from '@helpers/StoresHelper'
import { errorToast, successToast } from '@helpers/toastHelper'
import { defineStore } from 'pinia'
import SessionService from '~/app/services/SessionService'

export const useAuthStore = defineStore('auth', {
  state: () => {
    return {
      authenticatedUser: null as IUser | null,
      isLoggedIn: null as boolean | null,
    }
  },

  getters: {
  },

  actions: {

    async loadUser(): Promise<void> {
      if (!SessionService.session)
        return

      try {
        this.authenticatedUser = await AuthAdapter.getAuthenticatedUser()
        this.isLoggedIn = !!this.authenticatedUser
      }
      catch (e: any) {
        this.authenticatedUser = null
      }
    },

    async logout(): Promise<void> {
      await AuthAdapter.logout()
      this.authenticatedUser = null
      this.isLoggedIn = false
      window.location.href = '/'
    },

    async sendPasswordReset(email: string): Promise<void> {
      await AuthAdapter.requestPasswordReset(email)
    },

    async resetPassword(code: string, password: string): Promise<void> {
      const res = await AuthAdapter.confirmPasswordReset(code, password)
      if (res) {
        // showNotify({ type: 'success', message: t('notify.password_reset_success') })
        // showSuccessToast(t('notify.success'))
        await this.loadUser()
      }
      else {
        // showNotify({ type: 'danger', message: t('notify.request_failed') })
      }
    },

    async editAccount(data: IAccountEditDTO): Promise<void> {

    },

    async  login(data: ILoginDTO): Promise<void> {
      const res = await AuthAdapter.login(data)
      if (res) {
        successToast('Login success')
        await StoresHelper.initialiseStores()
      }
      else {
        errorToast('Incorrect login')
        throw new Error('Authentication failed')
      }
    },

    async  register(data: IRegisterDTO): Promise<void> {
      const res = await AuthAdapter.register(data)
      if (res) {
        successToast('Success')
        await StoresHelper.initialiseStores()
      }
      else {
        errorToast('Registration error')
      }
    },
  },
})
